import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {
  AangifteSchenkbelasting,
  APV, BokkzSbLogic,
  Effecten,
  GiftTaxEntity,
  NotarieleAkte,
  OmschrijvingEnBedrag,
  OndernemingSB,
  OnroerendeZaakSB,
  PU,
  RoerendeZaak,
  Schenking,
  SchenkingOpPapier,
  SchenkingRelatieBegiftigdeMetSchenker,
  Vrijstellingen,
  Vruchtgebruik
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {SelectFormControlItem, SharedUiFormControlsModule} from "@snelstart/ui-form-controls";
import {BokkzAlgDataService, BokkzSbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {SharedUiDetailsModule} from "@snelstart/ui-details";
import {Subscription} from "rxjs";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-schuldigerkenningen',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule
  ],
  templateUrl: './schuldigerkenningen.component.html',
  styleUrl: './schuldigerkenningen.component.css'
})
export class SchuldigerkenningenComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  private giftTaxEntitySubscription: Subscription | undefined;
  public giftTaxEntity = {} as GiftTaxEntity;
  public sbAangifte = {} as AangifteSchenkbelasting;
  public schenkingFg = {} as FormGroup;
  public schuldigerkenningFg = {} as FormGroup;
  public focusedElementId: string | null = null;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  constructor(
    public algDataService: BokkzAlgDataService,
    public dataService: BokkzSbDataService,
    public sbService: BokkzSbLogic,
    private fb: FormBuilder) {
    this.schenkingFg = this.fb.group<Schenking>({
      datumSchenking: null as unknown as Date,
      relatieBegiftigdeMetSchenker: null as unknown as SchenkingRelatieBegiftigdeMetSchenker,
      herroepelijkeSchenking: null as unknown as boolean,
      schenkerBetaaltDeSchenkbelasting: null as unknown as boolean,
      uitbreidingBegripSchenker: null as unknown as boolean,
      contanten: null as unknown as OmschrijvingEnBedrag,
      effecten: null as unknown as Effecten,
      onroerendeZaken: null as unknown as OnroerendeZaakSB,
      ondernemingen: null as unknown as OndernemingSB,
      apv: null as unknown as APV,
      periodiekeUitkering: null as unknown as PU,
      roerendeZaak: null as unknown as RoerendeZaak,
      schuldigerkenning: null as unknown as SchenkingOpPapier,
      kwijtscheldingSchuld: null as unknown as OmschrijvingEnBedrag,
      vruchtgebruik: null as unknown as Vruchtgebruik,
      overige: null as unknown as OmschrijvingEnBedrag,
      vrijstellingen: null as unknown as Vrijstellingen,
      notarieleAkte: null as unknown as NotarieleAkte,
      belastingBetaaldInAnderLand: null as unknown as number,
      landCodeBetaaldInAnderLand: null as unknown as string,
    })
    this.schuldigerkenningFg = this.fb.group<SchenkingOpPapier>({
      omschrijving: null as unknown as string,
      bedrag: null as unknown as number,
      rentePercentage: null as unknown as number,
      enkelvoudigeRente: false,
      datumAkte: null as unknown as Date,
      datumOpeisbaar: null as unknown as Date,
    })
  }

  ngOnInit(): void {
    this.giftTaxEntitySubscription = this.dataService.giftTaxEntity.subscribe((value)=> {
      this.giftTaxEntity = value;
      this.sbAangifte = value.aangifte!;
      if (value.aangifte!.schenking) {
        this.schenkingFg.patchValue(value.aangifte!.schenking[0], {emitEvent: false})
        if (value.aangifte!.schenking[0] && value.aangifte!.schenking[0].schuldigerkenning) {
          this.schuldigerkenningFg.patchValue(value.aangifte!.schenking[0].schuldigerkenning, {emitEvent: false})
        }
      }
    })
  }

  ngOnDestroy(): void {
    if (this.giftTaxEntitySubscription) {
      this.giftTaxEntitySubscription.unsubscribe()
    }
  }

  saveForm(): void {
    this.schuldigerkenningFg.updateValueAndValidity({ emitEvent: false });
    this.schenkingFg.updateValueAndValidity({ emitEvent: false });
    const schenking = this.schenkingFg.value;
    schenking.schuldigerkenning = {
      omschrijving: this.schuldigerkenningFg.value.omschrijving,
      bedrag: this.schuldigerkenningFg.value.bedrag,
      rentePercentage: this.schuldigerkenningFg.value.rentePercentage,
      enkelvoudigeRente: this.schuldigerkenningFg.value.enkelvoudigeRente,
      datumAkte: this.schuldigerkenningFg.value.datumAkte,
      datumOpeisbaar: this.schuldigerkenningFg.value.datumOpeisbaar,
    }
    this.giftTaxEntity.aangifte = {
      ...this.sbAangifte,
      schenking: [schenking],
    } as AangifteSchenkbelasting;
    this.dataService.updateGiftTaxEntity(this.giftTaxEntity);
    setTimeout(()=> {
      if (schenking.schuldigerkenning.bedrag != undefined
        && schenking.schuldigerkenning.rentePercentage != undefined
        && schenking.schuldigerkenning.enkelvoudigeRente != undefined)
      this.sbService.getCalculation();
    }, 1000)
  }
}
